import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
export var getMiniModalTheme = function getMiniModalTheme(contextTheme, propsTheme) {
  if (propsTheme === void 0) {
    propsTheme = {};
  }
  var theme = ThemeFactory.create(propsTheme, contextTheme);
  return ThemeFactory.create({
    modalBodyPaddingTop: theme.miniModalBodyPaddingTop,
    modalBodyPaddingBottom: theme.miniModalBodyPaddingBottom,
    modalHeaderPaddingTop: theme.miniModalHeaderPaddingTop,
    modalHeaderPaddingBottom: theme.miniModalHeaderPaddingBottom,
    modalFooterPaddingTop: theme.miniModalFooterPaddingTop,
    modalFooterPaddingBottom: theme.miniModalFooterPaddingBottom,
    mobileModalFooterPadding: theme.miniModalFooterPaddingMobile,
    mobileModalHeaderPadding: theme.miniModalHeaderPaddingMobile,
    mobileModalBodyPadding: theme.miniModalBodyPaddingMobile,
    mobileModalContainerHeight: theme.miniModalHeightMobile,
    mobileModalContainerMarginTop: theme.miniModalMarginTopMobile,
    mobileModalContainerMarginRight: theme.miniModalMarginRightMobile,
    mobileModalContainerMarginLeft: theme.miniModalMarginLeftMobile
  }, theme);
};